import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDetachKioskLabelMutation = (appointment_id: number) =>
  useTypedMutation<void, void>({
    mutationFn: async () => {
      await ApiInstance.post("/dashboard/labels/detach", { appointment_id }, ENV.kioskBaseURL);
    },
    onSuccess: () => typedQueryClient.invalidateQueries(AppointmentDetailsKeys.view)
  });
